module.exports = __webpack_public_path__ + "static/media/trash.cd62a9ed.svg";